'use client'

import type { StaticImageData } from 'next/image'

import { useCMSMenu } from '@/src/domains/cms-menus/hooks/useCMSMenu'
import { getCMSMenuItemHref } from '@/src/domains/cms-menus/utils/getCMSMenuItemHref'
import type { FetchStrapiMenu } from '@/src/domains/strapi/services/fetchStrapiMenu'

import { HeaderNavigationBusinessUI } from './HeaderNavigationBusiness.ui'

export interface HeaderNavigationBusinessProps {
  slug: FetchStrapiMenu['slug']
  image: string | StaticImageData
  title: string
}

export const HeaderNavigationBusiness = ({ slug, title, image }: HeaderNavigationBusinessProps) => {
  const { data } = useCMSMenu(slug)

  const links = data.map((item) => ({
    id: item.id,
    title: item.title,
    description: item.description ?? undefined,
    iconName: item.icon_name ?? 'user-rebrand',
    href: getCMSMenuItemHref(item),
  }))

  return <HeaderNavigationBusinessUI title={title} image={image} links={links} />
}
